/**
 * Zone.js configuration flags
 * These must be set BEFORE zone.js is loaded
 *
 * Disabling event patching prevents those events from triggering Angular CD.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'message',      // Keycloak SSO iframe polling
  'input',        // Text input - we handle manually
  'keydown',      // Keyboard - we handle Enter manually
  'keyup',        // Keyboard
  'keypress',     // Keyboard
  'compositionstart',  // IME input
  'compositionend',    // IME input
  'compositionupdate', // IME input
];
